
import { defineComponent } from 'vue';
import { ElConfigProvider } from 'element-plus';
//中文包
import zhCn from 'element-plus/lib/locale/lang/zh-cn';

export default defineComponent({
  name: 'APP',

  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },

  setup() {
    const debounce = (callback: (...args: any[]) => void, delay: number) => {
      let tid: any;
      return function (...args: any[]) {
        const ctx = self;
        tid && clearTimeout(tid);
        tid = setTimeout(() => {
          callback.apply(ctx, args);
        }, delay);
      };
    };

    const _ = (window as any).ResizeObserver;
    (window as any).ResizeObserver = class ResizeObserver extends _ {
      constructor(callback: (...args: any[]) => void) {
        callback = debounce(callback, 20);
        super(callback);
      }
    };
    let locale = zhCn;
    return {
      locale,
    };
  },
});
